export const GTM_EVENTS = {
    PAGE_VIEW: {
        name: 'cxp.pageview',
        displayName: 'CXP Page View',
    },
    SERVICE_COMPLETE: {
        name: 'service_complete',
        displayName: 'CXP Service Complete',
    },
};

export type ServiceActionsType = 'new' | 'renewal' | 'update' | 'withdrawal' | 'payment';

interface Window {
    gtag: (...args: any[]) => void;
    dataLayer: Record<string, any>;
}

declare let window: Window;

export const gtmEvent = (
    event: (typeof GTM_EVENTS)[keyof typeof GTM_EVENTS],
    document: Document,
    sessionId: string,
    userType: string,
    userId?: string,
    email?: string,
    pageReferrer?: string,
    params?: Record<string, any>
) => {
    if (!event || !document) {
        return;
    }

    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
        event: event.name,
        event_category: 'CXP App',
        event_label: event.displayName,
        page_path: document?.location?.pathname,
        page_location: document?.location?.href,
        page_title: document?.title,
        sessionId: sessionId ?? null,
        user_type: userType,
        page_referrer: pageReferrer ?? null,
        email: email ?? null,
        userId: userId ?? null,
        ...params,
    });
};

export const gtmServiceCompleteEvent = (
    serviceName: string,
    serviceItems: string,
    serviceAction: ServiceActionsType,
    value: string,
    completionTime: number
) => {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
        event: GTM_EVENTS.SERVICE_COMPLETE.name,
        service_name: serviceName?.toLowerCase(),
        service_items: serviceItems?.toLowerCase(),
        service_action: serviceAction,
        value: value,
        completion_time: completionTime,
        submission_id: crypto.randomUUID(),
    });
};

export const pushData = (data: Array<Record<string, any>>) => {
    if (!data) {
        return;
    }

    window.dataLayer = window.dataLayer || [];
    if (Array.isArray(data)) {
        window.dataLayer.push(...data);
    } else {
        window.dataLayer.push(data);
    }
};
